module.exports = __webpack_public_path__ + "img/xmark-to-slot.b98aea80.svg";